/* eslint-disable react-hooks/rules-of-hooks */
import ListingBox from './listing-box';
import Difference from './difference';
import SignMeUpDialog from './signme-up-dialog';
import { Consultant, MakePayment, SelectTenancy, SSubmit, Unactive } from '~components/svgs';
import React, { useState } from 'react';
import Details from './details';
import { useQuery } from '@apollo/client';
import { QUERY_Landlord_ListingPlan } from './queries';
import { Spin } from 'antd';
const data = [
  {
    title: 'List',
    color: 'y',
    description:
      'Ideal for property managers who want to communicate directly with students about their booking and payments',
    sign_up_button_text: 'Sign me up',
    student_experience: [
      {
        step: 1,
        action: 'Submit an application on Student.com',
        icon: {
          status: 'enabled',
          icon: <SSubmit style={{ width: '14px', flexShrink: 0 }} />,
        },
      },
      {
        step: 2,
        icon: {
          status: 'disabled',
          icon: <Consultant fColor="#BFBFBF" style={{ width: '14px', flexShrink: 0 }} />,
        },
        action:
          'Property manager reaches out to student directly through the contact details provided',
      },
      {
        step: 3,
        icon: {
          status: 'disabled',
          icon: <Unactive style={{ width: '14px', flexShrink: 0 }} />,
        },
        action: 'All further activities happen outside the site',
      },
    ],
    landlord_experience: [
      {
        title: 'Property Information',
        content: [
          {
            description: 'Can create and update on our Dashboard or sync in real-time via API.',
            icon_status: 'enabled',
          },
        ],
      },
      {
        title: 'Leads',
        content: [
          {
            description: "Manage orders on Dashboard (Student.com's backend system).",
            icon_status: 'enabled',
          },
          {
            description: 'Receive new lead notifications via Email.',
            icon_status: 'enabled',
          },
          {
            description:
              'Sync latest lead details through Open API/Customized API (e.g., Entrata).',
            icon_status: 'enabled',
          },
        ],
      },
      {
        title: 'Transactions',
        content: [
          {
            description: 'Not supported.',
            icon_status: 'disabled',
          },
        ],
      },
    ],
  },
  {
    title: 'Book',
    color: 'g',
    description:
      'Ideal for property managers who would like to review applications before accepting and receiving payment',
    sign_up_button_text: 'Sign me up',
    student_experience: [
      {
        step: 1,
        action: 'Submit an application on Student.com',
        icon: {
          status: 'enabled',
          icon: <SSubmit style={{ width: '14px', flexShrink: 0 }} />,
        },
      },
      {
        step: 2,
        icon: {
          status: 'enabled',
          icon: <Consultant style={{ width: '14px', flexShrink: 0 }} />,
        },
        action: 'Student gets notified when the property manager responds to their application',
      },
      {
        step: 3,
        icon: {
          status: 'enabled',
          icon: <MakePayment style={{ width: '14px', flexShrink: 0 }} />,
        },
        action:
          'If their application was accepted or there was a counter offer provided, student may pay directly on Student.com or to the property to confirm their booking',
      },
    ],
    landlord_experience: [
      {
        title: 'Property Information',
        content: [
          {
            description: 'Can create and update on our Dashboard or sync in real-time via API.',
            icon_status: 'enabled',
          },
        ],
      },
      {
        title: 'Leads',
        content: [
          {
            description: "Manage orders on Dashboard (Student.com's backend system).",
            icon_status: 'enabled',
          },
          {
            description: 'Receive new lead notifications via Email.',
            icon_status: 'enabled',
          },
          {
            description: 'Additional access to use the Dashboard management system.',
            icon_status: 'enabled',
          },
        ],
      },
      {
        title: 'Transactions',
        content: [
          {
            description:
              'Add payment methods on our Dashboard. Supported methods: Virtual Credit Card, Stripe, Bank Transfer.',
            icon_status: 'enabled',
          },
        ],
      },
    ],
  },
  {
    title: 'Connect',
    color: 'p',
    description:
      "Ideal for property managers who'd like to increase their conversion rates by allowing students to book and confirm instantly",
    sign_up_button_text: 'Sign me up',
    student_experience: [
      {
        step: 1,
        icon: {
          status: 'enabled',
          icon: <SSubmit style={{ width: '14px', flexShrink: 0 }} />,
        },
        action: 'Student starts their booking on Student.com',
      },
      {
        step: 2,
        icon: {
          status: 'enabled',
          icon: <SelectTenancy style={{ width: '14px', flexShrink: 0 }} />,
        },
        action: 'Based on calculated real-time availability, students may reserve a room',
      },
      {
        step: 3,
        icon: {
          status: 'enabled',
          icon: <MakePayment style={{ width: '14px', flexShrink: 0 }} />,
        },
        action: 'Pay online, receiving instant confirmation.',
      },
    ],
    landlord_experience: [
      {
        title: 'Property Information',
        content: [
          {
            description: 'Can create and update on our Dashboard or sync in real-time via API.',
            icon_status: 'enabled',
          },
        ],
      },
      {
        title: 'Leads',
        content: [
          {
            description: 'View order status on Dashboard.',
            icon_status: 'enabled',
          },
          {
            description: 'Receive new lead notifications via Email.',
            icon_status: 'enabled',
          },
          {
            description: 'Additional access to use the Student Suite management system.',
            icon_status: 'enabled',
          },
        ],
      },
      {
        title: 'Transactions',
        content: [
          {
            description:
              'Add payment methods on our Dashboard. Supported methods: Virtual Credit Card, Stripe, Bank Transfer.',
            icon_status: 'enabled',
          },
        ],
      },
    ],
  },
];
function index() {
  const [open, setOpen] = useState(null);

  const handleListingClick = type => {
    setOpen(type);
  };

  const [listingPlan, setListingPlan] = useState('');
  const [landlordId, setLandlordId] = useState('');
  const [refetchNumber, setRefetchNumber] = useState(0);
  const { loading } = useQuery(QUERY_Landlord_ListingPlan, {
    variables: {
      r: refetchNumber,
    },
    onCompleted: landlordData => {
      setLandlordId(landlordData?.viewer?.company.id);

      let str = landlordData?.viewer?.company?.listingPlan;
      if (str) {
        str = str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
        setListingPlan(str);
      }
    },
    fetchPolicy: 'network-only',
  });

  return (
    <div className="">
      <div
        style={{
          fontSize: '20px',
          fontWeight: 'bold',
          lineHeight: '32px',
          padding: '16px 24px',
          background: 'white',
          margin: '-1.25rem -2rem 2rem',
          borderTop: '1px solid rgba(0, 0, 0, 0.09)',
        }}
      >
        Listing Plan
      </div>
      {loading && <Spin />}
      {!loading && listingPlan && (
        <Details data={data} type={listingPlan} landlordId={landlordId} />
      )}
      {!loading && !listingPlan && (
        <>
          <div style={{ display: 'flex', gap: '20px', justifyContent: 'center' }}>
            {data.map(item => (
              <ListingBox
                color={item.color}
                onClick={handleListingClick}
                title={item.title}
                description={item.description}
                sign_up_button_text={item.sign_up_button_text}
                student_experience={item.student_experience}
                landlord_experience={item.landlord_experience}
              />
            ))}
          </div>
          {open && (
            <SignMeUpDialog
              activeModal={true}
              type={open}
              close={setOpen}
              landlordId={landlordId}
              callback={status => {
                if (status !== 'error') {
                  setOpen('');
                  setRefetchNumber(Math.random());
                }
              }}
            />
          )}
          <Difference />
        </>
      )}
    </div>
  );
}

export default index;
